import { useEffect, useRef, useState } from "react";
import { isScreenAwake, onScreenChange, startScreenWatch } from "../utils/screenAwake";

// Meet zolang het dashboard staat of deze tv echt iets laat zien, en geeft
// door wanneer het beeld wegvalt en terugkomt. Zie utils/screenAwake.js
// voor hoe dat gemeten wordt.
//
// onWake krijgt hoe lang het donker was. Daar hangt het dashboard het
// opnieuw ophalen aan: komt de tv om acht uur aan, dan wil je niet nog een
// minuut op de volgende ophaalronde wachten voor de kaart "Verkopen gemist"
// verschijnt. onDark stopt wat er nog loopt, want dat speelt tegen zwart.
export function useScreenAwake({ onWake, onDark } = {}) {
  const [awake, setAwake] = useState(isScreenAwake);

  // Via een ref, zodat een meeluisteraar die elke tekenronde opnieuw wordt
  // aangemaakt de meting niet steeds opnieuw start.
  const handlers = useRef({});
  handlers.current = { onWake, onDark };

  useEffect(() => {
    const stop = startScreenWatch();
    const off = onScreenChange(({ awake: now, sleptMs, darkAt }) => {
      setAwake(now);
      if (now) handlers.current.onWake?.({ sleptMs, darkAt });
      else handlers.current.onDark?.({ darkAt });
    });

    return () => {
      off();
      stop();
    };
  }, []);

  return awake;
}
